exports = module.exports = require("../../../../../../graylog2-server/graylog2-web-interface/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".archive-backend-details dt{float:left;width:160px;overflow:hidden;clear:left;text-align:left;text-overflow:ellipsis;white-space:nowrap}.archive-backend-details dd{margin-left:180px}.archive-backend-details dl{margin-bottom:0}.archive-backends-list .alert,.archive-backends-list .entity-list{margin-top:10px}.archive-backends-config form{margin-top:13px}.archive-backend-config-output-path-help{cursor:help;padding:0 0 0 2px;position:relative;top:-1px;left:-2px}.archive-backends-description{margin-bottom:0}.popover-wide{max-width:500px}", ""]);

// exports
